import cn from 'classnames'
import ReactTooltip from 'react-tooltip'

import Text from '~/components/Text'
import TrophyIcon from './assets/trophy.svg'
import defaultPurpleBgImg from './assets/purple-bg.png'

import styles from './Banner.pcss'

interface Props {
	className?: string
	title?: string
	hint?: string
	showIcon?: boolean
	backgroundImage?: string
	titleContainerClassName?: string
	children: React.ReactNode
}

export function Banner({
	className,
	title,
	hint,
	showIcon = true,
	backgroundImage = defaultPurpleBgImg,
	titleContainerClassName,
	children,
}: Props): JSX.Element {
	const isHintLink = hint?.includes('https://')

	const hintElement = isHintLink ? (
		<a
			className={styles.question}
			href={hint}
			target="_blank"
			rel="noreferrer"
		>
			{'{?}'}
		</a>
	) : (
		<span className={styles.question} data-tip data-for={hint}>
			{'{?}'}
		</span>
	)

	return (
		<div
			className={cn(styles.container, className)}
			style={{ backgroundImage: `url(${backgroundImage})` }}
		>
			{showIcon && <TrophyIcon className={styles.icon} />}
			<div className={cn(!showIcon && styles.fullWidth)}>
			<div className={cn(styles.titleContainer, titleContainerClassName)}>
				{title && (
					<>
						<Text className={styles.title} size="L">
							{title}
						</Text>

						{hint && hintElement}
					</>
				)}
			</div>

				{hint && (
					<ReactTooltip
						id={hint}
						place="right"
						effect="float"
						className={styles.tooltip}
						arrowColor="transparent"
						offset={{
							bottom: 20,
						}}
					>
						<div className={styles.hint}>{hint}</div>
					</ReactTooltip>
				)}

				<div
					className={cn(
						showIcon ? styles.description : styles.fullWidth
					)}
				>
					{children}
				</div>
			</div>
		</div>
	)
}
